import React from "react"
import { Layers, User, Users, UserX, Trash2, Copy } from "lucide-react"
import { cn } from "src/utils/cn"

// Ownership / state views shown as a tab strip above the leads table. These are
// orthogonal to the status/source dropdowns — they scope *which* leads are in
// view, not their pipeline stage.
export const LEAD_SCOPES = [
  { value: "all",        label: "All",        Icon: Layers },
  { value: "my",         label: "My Leads",   Icon: User },
  { value: "team",       label: "Team's",     Icon: Users },
  { value: "unassigned", label: "Unassigned", Icon: UserX },
  { value: "deleted",    label: "Deleted",    Icon: Trash2 },
  { value: "duplicate",  label: "Duplicate",  Icon: Copy },
]

function formatCount(n) {
  if (n == null) return null
  return n > 999 ? `${(n / 1000).toFixed(1)}k` : String(n)
}

export function LeadScopeTabs({ value, onChange, counts }) {
  return (
    <div
      role="tablist"
      aria-label="Lead views"
      className="flex items-center gap-1 overflow-x-auto rounded-xl border border-slate-200 bg-white p-1 shadow-sm"
    >
      {LEAD_SCOPES.map(({ value: v, label, Icon }) => {
        const active = value === v
        const count = counts ? formatCount(counts[v]) : null
        return (
          <button
            key={v}
            role="tab"
            type="button"
            aria-selected={active}
            onClick={() => onChange(v)}
            className={cn(
              "group flex shrink-0 items-center gap-2 rounded-lg px-3.5 py-2 text-[13px] font-medium transition-colors",
              active
                ? "bg-slate-900 text-white shadow-sm"
                : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
            )}
          >
            <Icon className={cn("h-4 w-4", active ? "text-white" : "text-slate-400 group-hover:text-slate-600")} />
            {label}
            {count != null && (
              <span
                className={cn(
                  "min-w-[1.25rem] rounded-full px-1.5 py-0.5 text-center text-[11px] font-semibold tabular-nums",
                  active ? "bg-white/20 text-white" : "bg-slate-100 text-slate-500 group-hover:bg-slate-200"
                )}
              >
                {count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
